import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IScope} from "angular";
import {Debugger} from "debug";
import {IStateParamsService} from "angular-ui-router";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";

const debug: Debugger = require('debug')('RedigerMøtereferatKontroller');
require('./redigerMøtereferat.scss');

export class RedigerMøtereferatKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular.component('wmRedigerMoeteReferat', {
            bindings: {
                moeteId: '<'
            },
            controller: RedigerMøtereferatKontroller.forInjisering(),
            template: require('./redigerMøtereferat.html')
        });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.ui.$stateParams,
            WebNavigasjon.regNavn,
            RedigerMøtereferatKontroller
        ]
    }

    constructor(public $scope: IScope, private $stateParams: IStateParamsService, private webNavigasjon: WebNavigasjon,) {
    }

    moeteId!: string; //settes via bindings/$onChanges

    gjenopprettSkjema(): boolean {
        return this.$stateParams.gjenopprettSkjema == true;
    }

    visGenerertForslag(): boolean {
        return this.$stateParams.visGenerertForslag == true;
    }

    vedAvsluttet(lagret: boolean) {
        //denne trigges av ng2-komponent - sørger derfor for at ajs fanger opp endringen
        this.$scope.$applyAsync(() => {
            if (lagret) {
                this.webNavigasjon.gåTilMøteProtokoll(this.moeteId, true);
            } else {
                this.webNavigasjon.gåTilMøteProtokoll(this.moeteId, true);
            }
        });
    }
}
